/*
 * @Author: Admni
 * @Description: 
 * @Date: 2020-12-24 16:46:24
 * @LastEditTime: 2021-02-26 14:45:51
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/layout'

Vue.use(VueRouter)
export const constantRouter = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   hidden: true,
  //   children: [{
  //     path: 'dashboard',
  //     name: 'Dashboard',
  //     component: () => import('@/views/dashboard/index'),
  //     meta: {
  //       title: '首页',
  //       icon: 'home'
  //     }
  //   }]
  // },
]


// role 1 客服 2 开发者
export const asyncRouter = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'cus',
    meta: {
      role: [1]
    },
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: {
        title: '首页',
        icon: 'home'
      }
    }]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'dev',
    meta: {
      role: [2]
    },
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: () => import('@/views/dashboard-dev/index'),
      meta: {
        title: '首页',
        icon: 'home',
      }
    }]
  },
  {
    path: '/problem-dev',
    component: Layout,
    redirect: '/prob/index',
    name: 'problem-dev',
    meta: {
      role: [2]
    },
    children: [{
      path: 'index',
      name: 'index',
      component: () => import('@/views/problem-dev/index'),
      meta: {
        title: '开发问题',
        icon: 'kaifa'
      }
    }]
  },

  {
    path: '/chat',
    component: Layout,
    redirect: '/chat/index',
    name: 'chat',
    meta: {
      title: '对话平台',
      icon: 'kchat',
      role: [1]
    },
    children: [
      // {
      //   path: 'index/1',
      //   name: 'index/1',
      //   component: () => import('@/views/chat/index'),
      //   meta: { title: 'snail-ios', icon: 'app', pkg: 'com.snailvpn.iosproxy' }
      // },
      // {
      //   path: 'index/2',
      //   name: 'index/2',
      //   component: () => import('@/views/chat/index'),
      //   meta: { title: 'snail-android', icon: 'app', pkg: 'com.snailvpn.androidproxy' }
      // },
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/chat/index'),
        meta: {
          title: '在线聊天',
          icon: 'kchat',
          pkg: 'ufovpn.unblock.proxy.vpn'
        }
      },
      {
        path: 'wait',
        name: 'wait',
        component: () => import('@/views/wait-list/index'),
        meta: {
          title: '等待列表',
          icon: 'wait',
          pkg: 'ufovpn.unblock.proxy.vpn'
        }
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('@/views/user/index'),
        meta: {
          title: '用户列表',
          icon: 'users',
          pkg: 'ufovpn.unblock.proxy.vpn'
        }
      },
    ]
  },

  {
    path: '/set',
    component: Layout,
    name: 'set',
    meta: {
      role: [1]
    },
    children: [{
      path: 'set',
      name: 'Set',
      component: () => import('@/views/set/index'),
      meta: {
        title: '设置',
        icon: 'shezhi',
        role: [1]
      }
    }]
  },

  // 404 page must be placed at the end !!!
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouter
})

const router = createRouter()


export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router